import GameCardUI from "./GameCardUI";
import station_card from "../../../images/gameplay_ui/cards/back/station_card_back.png";
import front_image from "../../../images/gameplay_ui/cards/station_image.png";
import GameWindowHeader from "../GameWindowHeader";
import {GetColorByTypeAndID} from "../GameStyleUI";
import {GetNameByTypeAndID} from "../../../constants/Constants";
export default class StationGameCardUI extends GameCardUI{
    render() {
        let card = this.props.card;
        let styleFront= {
            position: "absolute",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            left: "0px",
            top: "0px",
            width: `${this.cardWidth}px`,
            height: `${this.cardHeight}px`,
            transform:`scale(${this.state.frontWidth}, ${this.state.backHeight})`,
            background: "#F2F2F2",
            borderRadius: "3px"
        }
        let bottomStyle = {
            background: "white",
            width: "310px",
            height: "64px"
        }
        this.cardBack = station_card;
        if(!card.isLucky){
            let colors = GetColorByTypeAndID(card.type, card.id);
            this.contentCard = <div style={styleFront} onClick={this.hide.bind(this)} >
                <div style={{height:"10px"}}></div>
                <GameWindowHeader width={310}
                                  height={60}
                                  colorStart={colors[0]}
                                  colorEnd={colors[1]}
                                  title={GetNameByTypeAndID(card.type, card.id)}
                                  fontSize={20}
                />
                <img src={front_image} alt={"icon"}/>
                <div style={bottomStyle}>
                    <div style={{paddingTop: "10px"}}><b>ПРОГУЛЫ</b></div>
                    <div>Потеря {card.value} трудозатрат</div>
                </div>
            </div>
        }
        return super.render();
    }
}
